import { style } from "@vanilla-extract/css";

import { theme } from "@huub-web/ui/theme/css/theme.css";

export const containerStyle = style({
  padding: theme.spacings.s,
  backgroundColor: theme.colors.tertiary,
  color: theme.colors.onTertiary,
  borderRadius: theme.borderRadiuses.s,
  width: "100%",
});

export const textStyle = style({
  flexGrow: 1,
});
